var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIconHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_42",
    "data-name": "Group 42",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Speech_Bubble_48_",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M3.4,52.191H1.747l1.172-1.232a4.259,4.259,0,0,0,1.133-2.466,9.29,9.29,0,0,1-3.5-4.351A8.937,8.937,0,0,1,.317,38.68a10.693,10.693,0,0,1,3.9-5.719,12.3,12.3,0,0,1,7.52-2.425,12.229,12.229,0,0,1,8.693,3.116,9.588,9.588,0,0,1,2.962,6.974,9.684,9.684,0,0,1-2.968,6.993,12.2,12.2,0,0,1-8.687,3.128A15.076,15.076,0,0,1,7.8,50.221a6,6,0,0,1-4.4,1.97ZM11.733,31.98c-5.676,0-9.16,3.56-10.093,7.088a7.416,7.416,0,0,0,3.48,8.427l.342.217-.011.42A5.923,5.923,0,0,1,4.9,50.487a4.863,4.863,0,0,0,2.15-1.547l.29-.361.43.135a13.553,13.553,0,0,0,3.957.589c7.065,0,10.282-4.5,10.282-8.678A8.126,8.126,0,0,0,19.5,34.717a10.929,10.929,0,0,0-7.766-2.738Z",
    transform: "translate(0 -30.536)",
    fill: "#00aeef"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconHover);
export default __webpack_public_path__ + "static/media/chatIconHover.d057a6cbe61811f25b20f85548b2aac9.svg";
export { ForwardRef as ReactComponent };